/* Richtpreise der Ernährung (11.10.2026): Der Server rechnet aus dem Preis je kg der Lebensmittel, hier wird nur
   angezeigt — immer mit „ca.“, Komma und Euro-Zeichen hinter der Zahl. Fehlt einer Zutat der Preis, steht kein Betrag
   da (er wäre zu niedrig), sondern welche Zutaten keinen Preis haben. */

export const euro = (v) => `${Number(v || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

/* Eingabe „2,98“ oder „2.98“ (auch mit „ €“ dahinter) -> Zahl; leer -> null (= Preis unbekannt), alles andere -> NaN.
   Nur Ziffern mit höchstens einem Komma oder Punkt: Number() allein nähme auch „1e2“, „0x10“ oder „2 98“ als Zahl. */
export function preisZahl(text) {
  const t = String(text ?? '').trim().replace(/\s*€$/, '');
  if (t === '') return null;
  return /^\d+([.,]\d+)?$/.test(t) ? Number(t.replace(',', '.')) : NaN;
}

export const preisEingabe = (v) => (v === null || v === undefined ? '' : Number(v).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false }));

/* „ca. 2,15 €“ — für mehrere Personen der Gesamtpreis; null, wenn es keinen (vollständigen) Preis gibt */
export function preisText(p, { personen = 1 } = {}) {
  if (!p || !p.vollstaendig) return null;
  if (personen > 1 && p.gesamt !== undefined) return `ca. ${euro(p.gesamt)} für ${personen} Personen (${euro(p.euro)} je Portion)`;
  return `ca. ${euro(p.euro)}`;
}

/* Lange Listen (ein ganzer Plan ohne Preise) kürzen: „Mango, Rucola, Feta, Lachs und 12 weitere“ */
export function namenKurz(namen, hoechstens = 4) {
  const liste = namen || [];
  if (liste.length <= hoechstens + 1) return liste.join(', ');          // „und 1 weitere“ spart nichts
  return `${liste.slice(0, hoechstens).join(', ')} und ${liste.length - hoechstens} weitere`;
}

export function preisFehlt(p) {
  if (!p || p.vollstaendig) return null;
  return `Preis fehlt für: ${namenKurz(p.ohne) || 'eine Zutat'}`;
}

/* Eine Zeile: Betrag oder der Hinweis, wem der Preis fehlt. `davor`/`danach` rahmen nur den Betrag. */
export function Preis({ p, personen = 1, davor = '', danach = '', className = '' }) {
  if (!p) return null;
  const text = preisText(p, { personen });
  if (text) return <span className={`tabular-nums ${className}`}>{davor}{text}{danach}</span>;
  return <span className={`text-amber-700 ${className}`} title={(p.ohne || []).length > 5 ? p.ohne.join(', ') : undefined}>{preisFehlt(p)}</span>;
}
